<div class="form-check form-switch">
  <input class="form-check-input pointer" type="checkbox"
    autocomplete="off"
    [class.is-invalid]="showError"
    [formControl]="switchFormControl"
    [formlyAttributes]="field">
  <label class="form-check-label pointer" [for]="id">
    {{ props.label }}
    @if (props.required && props.hideRequiredMarker !== true) {
      <span>*</span>
    }
  </label>
</div>
